import { NgTemplateOutlet } from '@angular/common';
import { Component, effect, ElementRef, HostListener, inject, input, model, OnInit, output, TemplateRef, viewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'core-drop-button',
  imports: [NgTemplateOutlet],
  templateUrl: './core-drop-button.component.html',
  styleUrl: './core-drop-button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CoreDropButtonComponent implements OnInit {
  dropClick = output<any>();
  selectedItems = model<any | null>();
  items = input.required<any[]>();
  buttonRef = viewChild<ElementRef>('buttonRef');
  dropdownListRef = viewChild<ElementRef>('dropdownList');
  elementRef = inject(ElementRef);
  template = input.required<TemplateRef<any>>();
  headTemplate = input<TemplateRef<any>>();
  valueKey = input.required<string>();
  multiSelect = input<boolean>(false);
  selectionRequired = input<boolean>(true);
  closeMenuAfterClick = input<boolean>(true);
  maximumSelection = input<number>(2);
  dropIsOpen = false;
  openUpwards = false;

  @HostListener('window:resize')
  onWindowChange() {
    this.dropIsOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.dropIsOpen = false;
    }
  }

  ngOnInit(): void {
    // this.findingSelectedItem();
  }

  toggleDropdown() {
    this.dropIsOpen = !this.dropIsOpen;

    setTimeout(() => {
      if (this.dropIsOpen) {
        this.checkSpaceAndSetDirection();
      }
    }, 1);
  }

  checkSpaceAndSetDirection() {
    if (!this.buttonRef() || !this.dropdownListRef()) {
      return;
    }

    const buttonRect = this.buttonRef()!.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const dropdownHeight = this.dropdownListRef()!.nativeElement.offsetHeight || 0;

    const spaceBelow = viewportHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;

    this.openUpwards = spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;
  }

  onClick(event: Event, item: any) {
    (event.target as HTMLElement).blur();

    if (item.disable) {
      return;
    }

    if (this.closeMenuAfterClick()) {
      this.dropIsOpen = false;
    }

    if (!this.multiSelect()) {
      if (!this.selectionRequired() && this.selectedItems() && this.selectedItems()[this.valueKey()] === item[this.valueKey()]) {
        this.selectedItems.set(null);
      } else {
        this.selectedItems.set(item);
      }
    } else {
      if (this.selectedItems() && Array.isArray(this.selectedItems())) {
        const index = this.selectedItems().findIndex((i: any) => i[this.valueKey()] === item[this.valueKey()]);
        if (index > -1) {
          if (this.selectedItems().length === 1 && this.selectionRequired()) {
            return;
          }
          this.selectedItems().splice(index, 1);
        } else {
          if (this.maximumSelection() && this.selectedItems().length >= this.maximumSelection()) {
            return;
          }
          this.selectedItems().push(item);
        }
      } else {
        this.selectedItems.set([item]);
      }
    }

    this.dropClick.emit(this.selectedItems());
  }

  checkSelected(item: any): boolean {
    if (this.multiSelect()) {
      return this.selectedItems() && Array.isArray(this.selectedItems()) && this.selectedItems().some((i: any) => i[this.valueKey()] === item[this.valueKey()]);
    }
    return this.selectedItems() && this.selectedItems()[this.valueKey()] === item[this.valueKey()];
  }

  // private findingSelectedItem() {
  //   if (this.items && this.selectionRequired()) {

  //     if (this.multiSelect()) {
  //       this.selectedItems.set([this.items().find((item) => item.default) || this.items()[0]]);
  //       this.dropClick.emit(this.selectedItems())
  //       return
  //     }

  //     this.selectedItems = this.items().find((item) => item.default) || this.items()[0];
  //     this.dropClick.emit(this.selectedItems())

  //   }
  // }
}
